import { api, setConfig } from '../..';
import { mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getRoles = (data: PropertyType): Promise<PropertyType> =>
	api.post('/user/roles', { sid: data.token }, setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
